module.exports = __webpack_public_path__ + "img/infor3.3f192cc8.png";